<script>
import moment from 'moment';

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

    colorBadge(color, item, value) {
      // console.log(color);
      let badge = (!('color' in item) || !item.color) ? 
        'badge bg-info font-size-12 m-1' : 
        `badge bg-${color} font-size-12 m-1`;

      let hexColor = color.includes('#') ? `;background-color: ${color}` : '';

      return `<a class="${badge}" style="padding: 5px${hexColor}">${value}</a>`
    },  

    formatDate : function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

  },
  computed: {
    
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
    },
    formats: {
      type: Array,
    },
    filters: null,
    
  },
};
</script>
<template>
  <div v-if="formats.some(format => format.name == item.name)">
    <div v-for="(format, index) in formats" :key="index">
      <div v-if="format.name == item.name">
        <div v-if="'type' in format">
          <div v-if="format.type == 'date'">{{item.value ? formatDate(item.value) : ''}}</div>
          <div v-else-if="format.type == 'currency'" :style="'style' in format ? format.style : ''">
            {{ 'sign' in format ? format.sign + filters.numFormat(item.value, `0,0${'decimal' in format ? format.decimal : '.00'}`) 
                : filters.numFormat(item.value, `0,0${'decimal' in format ? format.decimal : '.00'}`)}}
          </div>
          <div v-else-if="format.type == 'suffix'">
            {{ 'sign' in format ? item.value + format.sign : item.value}}
          </div>
          <div v-else-if="format.type == 'fast-view'">
            <a @click="$emit('view', {id: item.id, name: item.value, object: item.object})" class="font-size-12 m-1" style="padding: 5px">{{item.value}}</a>
          </div>
          <div v-else>{{item.value}}</div>
        </div>
        
        <div v-else>
          <div v-if="'color' in format">
            <div v-if="typeof(format.color) == 'string'" v-html="colorBadge(item.object[format.color], format, item.value)"></div> 
            <div v-else v-html="colorBadge(item.color, format, item.value)"></div> 
          </div>
          
          <div v-else><a class="badge bg-info font-size-12 m-1" style="padding: 5px"> {{item.value}}</a></div>
        
        </div>
      </div>
    </div>
  </div>
  <div v-else v-html="item.value">
    <!-- {{item.value}} -->
  </div>
</template>